export const COMPANY = {
    name: "Lavlimpar",
    tagline: "Especialistas em Limpeza Técnica de Hottes e Sistemas de Extração",
    slogan: "Profissionalismo que garante segurança e higiene.",
    subtitle: "Garantimos higiene, segurança e eficiência para a sua cozinha industrial.",
    phone: "916 542 592",
    phoneIntl: "+351916542592",
    contactName: "Miguel Castilho",
    email: "defv.lavlimpar@gmail.com",
    serviceAreas: ["Lisboa", "Porto", "Algarve"],
    whatsappMessage:
        "Olá Miguel, vim através do website da Lavlimpar e gostaria de pedir um orçamento.",
};

export const WHATSAPP_URL = `https://wa.me/${COMPANY.phoneIntl.replace(
    "+",
    ""
)}?text=${encodeURIComponent(COMPANY.whatsappMessage)}`;

// Real Lavlimpar work photos served from /public/photos/
const photo = (name) =>
    typeof name === "number"
        ? `/photos/work-${name}.jpg`
        : `/photos/${name}`;

export const IMAGES = {
    hero: photo(29),
    gallery: [
        photo("work-43.jpg"),
        photo(33),
        photo("work-44.webp"),
        photo(11),
        photo(34),
        photo("work-45.webp"),
        photo(35),
        photo(4),
        photo("work-46.jpg"),
        photo(36),
        photo(37),
        photo("work-47.jpg"),
        photo(38),
        photo(26),
        photo(39),
        photo(6),
        photo(40),
        photo(20),
        photo(41),
        photo(42),
        photo(22),
        photo(8),
    ],
};

export const SERVICES = [
    {
        id: "hottes",
        number: "01",
        title: "Limpeza de Hottes Industriais",
        short: "Desengorduramento profundo de hottes industriais em cozinhas profissionais.",
        bullets: [
            "Desengorduramento completo interior e exterior",
            "Remoção profunda de gordura acumulada",
            "Higienização e desinfeção certificadas",
            "Cumprimento das normas HACCP e segurança contra incêndio",
        ],
        image: photo(2),
        alt: "Limpeza profissional de hotte industrial em cozinha de restauração",
    },
    {
        id: "condutas",
        number: "02",
        title: "Limpeza de Condutas e Extração de Fumos",
        short: "Limpeza técnica de condutas e sistemas de extração para cozinhas industriais.",
        bullets: [
            "Limpeza técnica integral de condutas",
            "Desengorduramento do sistema de extração de fumos",
            "Redução drástica do risco de incêndio",
            "Maior eficiência da ventilação industrial",
        ],
        image: photo(19),
        alt: "Limpeza de condutas e sistema de extração de fumos em cozinha industrial",
    },
    {
        id: "motores",
        number: "03",
        title: "Limpeza de Motores e Ventiladores",
        short: "Recuperação total da performance de motores, turbinas e ventiladores industriais.",
        bullets: [
            "Limpeza de motores de extração",
            "Limpeza de turbinas e ventiladores industriais",
            "Remoção de gordura, fuligem e resíduos",
            "Diagnóstico de funcionamento e desgaste",
        ],
        image: photo(23),
        alt: "Motor e ventilador industrial após desengorduramento profissional",
    },
    {
        id: "manutencao",
        number: "04",
        title: "Manutenção Periódica de Cozinhas Industriais",
        short: "Planos de manutenção preventiva mensais, trimestrais ou personalizados.",
        bullets: [
            "Limpezas técnicas especializadas",
            "Manutenção preventiva programada",
            "Intervenções periódicas com relatório",
            "Planos personalizados por tipo de cozinha",
        ],
        image: photo(30),
        alt: "Manutenção e limpeza técnica preventiva de cozinha industrial",
    },
];

export const SERVICE_TYPES = [
    "Limpeza de Hottes Industriais",
    "Limpeza de Condutas e Extração",
    "Limpeza de Motores e Ventiladores",
    "Manutenção Periódica",
    "Limpeza Completa de Cozinha Industrial",
];

export const TARGET_CLIENTS = [
    "Restaurantes",
    "Hotéis",
    "Pastelarias",
    "Churrasqueiras",
    "Cozinhas Industriais",
    "Empresas de Restauração",
];

export const TESTIMONIALS = [
    {
        name: "Restaurante O Cantinho",
        role: "Proprietário",
        text: "Serviço extremamente profissional. A diferença no sistema de extração ficou imediatamente visível. Recomendo totalmente.",
    },
    {
        name: "Hotel Praia Verde",
        role: "Direção F&B",
        text: "Equipa pontual, organizada e muito cuidadosa. Excelente limpeza das hottes e condutas da nossa cozinha industrial.",
    },
    {
        name: "Pastelaria Doce Mel",
        role: "Gerência",
        text: "Trabalho impecável e atendimento muito profissional. Voltaremos a contratar sem dúvida.",
    },
    {
        name: "Churrasqueira do Bairro",
        role: "Chefe de cozinha",
        text: "Grande atenção ao detalhe e excelente comunicação durante todo o processo de desengorduramento.",
    },
    {
        name: "Snack-bar Estação",
        role: "Encarregado",
        text: "Resultado final excelente. A cozinha ficou muito mais limpa, segura e a funcionar melhor.",
    },
];
